import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const StixStars = (props) => (
  <Fragment>
    {props.totalStars} estrela{props.totalStars > 1 && 's'}
  </Fragment>
)

StixStars.propTypes = {
  totalStars: PropTypes.number
}
export default StixStars



// WEBPACK FOOTER //
// ./src/features/Stix/StixStars.js